// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UseLongClick = require("./UseLongClick.res.js");
var Paper = require("@mui/material/Paper").default;

function LongClickPaper(props) {
  var match = UseLongClick.useLongClick(props.onClick, props.longClickEnabled, props.longClickDelayMs, props.onShortClick, props.onLongClick);
  return React.createElement(Paper, {
              ref: props.ref_,
              style: props.style,
              title: props.title,
              onClick: match.onClick,
              onMouseDown: match.onMouseDown,
              onMouseUp: match.onMouseUp,
              onMouseMove: match.onMouseMove,
              onMouseLeave: match.onMouseLeave,
              onMouseOut: match.onMouseOut,
              onTouchStart: match.onTouchStart,
              onTouchEnd: match.onTouchEnd,
              onTouchMove: match.onTouchMove,
              onTouchCancel: match.onTouchCancel,
              children: Caml_option.some(props.children)
            });
}

var make = LongClickPaper;

exports.make = make;
/* react Not a pure module */
